import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add up to 2 games for 20% off your tickets, 3 games for 30% off or 4+ games for 40% off your tickets.",
  progressBarAditionalText: " to continue!",
};

export const SpringfieldCardinalsLink = ({
  fontWeight,
  text,
}: {
  fontWeight?: number;
  text?: string;
}) => (
  <Link
    href={"https://mlb.tickets.com/?agency=SPCM_MYTIXX&orgid=57050#/auth/login"}
    target={"_blank"}
    sx={{
      fontWeight: fontWeight || 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    {text ?? "MyProVenue"}
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description: (
      <>
        Click Continue and connect your{" "}
        <SpringfieldCardinalsLink text="My Cardinals Tickets account" /> using
        our secure MiLB.com login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <SpringfieldCardinalsLink /> within 24
        hours of purchase. Reach out to LIve Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Springfield Cardinals Flex Program work?",
    description:
      "The Springfield Cardinals Flex Program allows fans to select any seat to select games hosted by the Springfield Cardinals. Simply log into your MiLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your{" "}
        <SpringfieldCardinalsLink text="My Cardinals Tickets MyProVenue Account" />{" "}
        within 24 hours.
      </>
    ),
  },
];

export const RegistrationTerms = () => (
  <>
    By checking this box you agree to receive notifications from the Springfield
    Cardinals and agree to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    By purchasing you agree to receive notifications regarding your purchase and
    to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
